import React from 'react'
import styled from 'styled-components'
import Close from '../Close'

const Container = styled.div`
  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0.97917) 4.7%, rgba(0, 0, 0, 0.95603) 8.9%, rgba(0, 0, 0, 0.9296) 12.8%, rgba(0, 0, 0, 0.898904) 16.56%, rgba(0, 0, 0, 0.862963) 20.37%, rgba(0, 0, 0, 0.8208) 24.4%, rgba(0, 0, 0, 0.771437) 28.83%, rgba(0, 0, 0, 0.713896) 33.84%, rgba(0, 0, 0, 0.6472) 39.6%, rgba(0, 0, 0, 0.57037) 46.3%, rgba(0, 0, 0, 0.48243) 54.1%, rgba(0, 0, 0, 0.3824) 63.2%, rgba(0, 0, 0, 0.269304) 73.76%, rgba(0, 0, 0, 0.142163) 85.97%, rgba(0, 0, 0, 0) 100%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 168px;
  display: grid;
  place-items: center;
  color: white;

  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 100%;
    position: relative;
    transform: translate(0, -5px);
    text-align: center;
  }

  h1 {
    font-size: ${({ theme }) => theme.old.fonts.size.large};
    font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
    line-height: 32px;
    max-width: 60vw;

    ${({ theme }) => theme.old.breakpoints.isMobile} {
      font-size: ${({ theme }) => theme.old.fonts.size.semilarge};
      line-height: 28px;
    }
  }

  h2 {
    font-size: ${({ theme }) => theme.old.fonts.size.normal};
    font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
    line-height: 24px;
    max-width: 80vw;

    ${({ theme }) => theme.old.breakpoints.isMobile} {
      font-size: ${({ theme }) => theme.old.fonts.size.small};
      line-height: 20px;
    }
  }
`

const Header = ({ title: Title, description, onClose }) => {

  const isTitleComponent = typeof Title === 'function'

  return (
    <Container>
      <div>
        <Close onClick={onClose} />
        <h1>{isTitleComponent ? <Title /> : Title}</h1>
        <h2>{description}</h2>
      </div>
    </Container>
  )
}

export default Header